import { Injectable } from '@angular/core';
import envJson from '../env';

export type ENV = { [key: string]: string };

@Injectable({
  providedIn: 'root',
})
export default class EnvService {
  private readonly env: ENV;

  constructor() {
    this.env = JSON.parse(document.getElementById('client-env')?.innerHTML || '{}') as ENV;
    const useEnvJson = Object.keys(this.env).length === 1 && !!this.env['VOID'];
    this.env = useEnvJson ? JSON.parse(envJson) as ENV : this.env;
    this.env['PUBLIC_CLIENT_DOMAIN'] = useEnvJson ? '/api' : this.env['PUBLIC_CLIENT_DOMAIN'];
    this.env['BUSINESS_CLIENT_DOMAIN'] = useEnvJson ? '/business' : this.env['BUSINESS_CLIENT_DOMAIN'];
  }

  value(key: string) {
    return this.env[key];
  }
}
